import { connect } from 'react-redux'
import observersSelector from './observersSelector'
import Observers from './Observers'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  observersSelector,
  {}
)(Observers))
